(function () {
  if (window.BCJPdpPurchaseOptions) {
    window.BCJPdpPurchaseOptions.initialize(document);
    return;
  }

  function allocationCadence(allocation) {
    var options = allocation && allocation.options || [];
    return JSON.stringify(options.length ? options.map(function(option) {
      return String(option.value || '').trim().toLowerCase();
    }) : [String(allocation && allocation.name || '').trim().toLowerCase()]);
  }

  function monthlyAllocation(allocations) {
    return allocations.find(function(allocation) {
      return /^(every month|monthly)$/.test(String(allocation.name || '').trim().replace(/\s+/g, ' ').toLowerCase());
    }) || allocations[0] || null;
  }

  function initialize(scope) {
    var roots = scope.matches && scope.matches('[data-bpdp]') ? [scope] : Array.prototype.slice.call(scope.querySelectorAll('[data-bpdp]'));
    roots.forEach(function (root) {
      if (root.bcjPurchaseOptions) return;
      var form = root.querySelector('[data-bpdp-form]');
      var holder = form && form.querySelector('[data-bpdp-plan-holder]');
      if (!holder) return;
      var input = holder.querySelector('[data-bpdp-selling-plan]');
      var select = holder.querySelector('[data-bpdp-purchase-select]');
      var details = holder.querySelector('[data-bpdp-purchase-details]');
      var cadence = holder.querySelector('[data-bpdp-purchase-cadence]');
      var error = holder.querySelector('[data-bpdp-purchase-error]');
      var data;
      try { data = JSON.parse(holder.querySelector('[data-bpdp-purchase-data]').textContent); } catch (_) { data = null; }
      var variants = {};
      Object.keys(data && data.variants || {}).forEach(function (id) {
        var variant = data.variants[id];
        if (variant && typeof variant.requiresSellingPlan === 'boolean' && Array.isArray(variant.allocations)) variants[id] = variant;
      });
      var copy = data && data.copy || {};
      var variantId = null;
      var signature = null;
      var publishing = false;

      function currentVariant() {
        return Object.prototype.hasOwnProperty.call(variants, variantId) ? variants[variantId] : null;
      }

      function getAllocation() {
        var variant = currentVariant();
        return variant && variant.allocations.find(function (allocation) { return String(allocation.id) === input.value; }) || null;
      }

      function isValid() {
        var variant = currentVariant();
        return Boolean(variant && (input.value ? getAllocation() : !variant.requiresSellingPlan));
      }

      function moneyCopy(key, amount) {
        return String(copy[key] || '').replace('__AMOUNT__', amount);
      }

      function publish(previousValue) {
        var allocation = getAllocation();
        var valid = isValid();
        var nextSignature = [variantId, input.value, valid].join('|');
        holder.dataset.bpdpPlanValid = String(valid);
        error.hidden = valid;
        error.textContent = valid ? '' : copy.unavailable || '';
        if (nextSignature === signature || publishing) return;
        signature = nextSignature;
        publishing = true;
        try {
          if (previousValue !== input.value) input.dispatchEvent(new Event('change', { bubbles: true }));
          root.dispatchEvent(new CustomEvent('bcj:pdp-purchase-change', { bubbles: true, detail: { allocation: allocation, valid: valid, requiresSellingPlan: Boolean(currentVariant() && currentVariant().requiresSellingPlan) } }));
        } finally { publishing = false; }
      }

      function render(previousValue) {
        var variant = currentVariant();
        var allocation = getAllocation();
        var options = [];
        function appendOption(value, text, disabled) {
          var option = document.createElement('option');
          option.value = value;
          option.textContent = text;
          option.disabled = Boolean(disabled);
          options.push(option);
        }
        if (variant && !variant.requiresSellingPlan) appendOption('', copy.oneTime || '');
        if (variant) variant.allocations.forEach(function (item) { appendOption(String(item.id), item.name + ' — ' + item.priceStr); });
        if (!variant || variant.requiresSellingPlan && !variant.allocations.length) appendOption('', copy.unavailable || '', true);
        if (input.value && !allocation) appendOption('__invalid__', copy.unavailable || '', true);
        select.replaceChildren.apply(select, options);
        select.value = allocation ? String(allocation.id) : input.value ? '__invalid__' : '';
        select.required = Boolean(variant && variant.requiresSellingPlan);
        select.disabled = Boolean(!variant || root.querySelector('[data-bpdp-atc].is-loading, [data-bpdp-atc][aria-busy="true"]'));
        holder.hidden = Boolean(variant && !variant.requiresSellingPlan && !variant.allocations.length && !input.value);
        var priceParts = [];
        if (allocation) {
          priceParts.push(moneyCopy('perDelivery', allocation.perDeliveryPriceStr));
          if (allocation.checkoutCharge !== allocation.perDeliveryPrice) priceParts.push(moneyCopy('checkoutCharge', allocation.checkoutChargeStr));
          if (allocation.recurringCharge !== allocation.price) priceParts.push(moneyCopy('recurringCharge', allocation.recurringChargeStr));
        }
        details.textContent = priceParts.join(' · ');
        details.hidden = !allocation;
        cadence.textContent = allocation ? (allocation.options || []).map(function (option) { return [option.name, option.value].filter(Boolean).join(': '); }).join(' · ') : '';
        cadence.hidden = !cadence.textContent;
        publish(previousValue);
      }

      function syncVariant(id) {
        var nextId = id == null ? null : String(id);
        if (nextId === variantId) {
          var currentSignature = [variantId, input.value, isValid()].join('|');
          if (currentSignature !== signature && !publishing) render(input.value);
          return getAllocation();
        }
        var previousValue = input.value;
        var previousAllocation = getAllocation();
        var wasSubscription = Boolean(previousAllocation);
        variantId = nextId;
        var variant = currentVariant();
        var preserved = variant && variant.allocations.find(function (allocation) { return String(allocation.id) === previousValue; });
        var sameCadence = previousAllocation && variant && variant.allocations.find(function(allocation) {
          return allocationCadence(allocation) === allocationCadence(previousAllocation);
        });
        var selected = preserved || sameCadence || variant && (wasSubscription || variant.requiresSellingPlan) && monthlyAllocation(variant.allocations);
        input.value = selected ? String(selected.id) : '';
        render(previousValue);
        return getAllocation();
      }

      root.bcjPurchaseOptions = { syncVariant: syncVariant, getAllocation: getAllocation, isValid: isValid };
      select.addEventListener('change', function () {
        var previousValue = input.value;
        input.value = select.value;
        render(previousValue);
      });
      input.addEventListener('change', function () { if (!publishing) render(input.value); });
      root.addEventListener('bcj:pdp-variant-change', function (event) { syncVariant(event.detail && event.detail.id); });
      var idInput = form.querySelector('[data-bpdp-id]');
      syncVariant(idInput && idInput.value);
    });
  }

  window.BCJPdpPurchaseOptions = { initialize: initialize };
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
})();
